import React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

const AppleLogo: React.FC<SvgProps> = (props) => {
    return (
        <Svg width={31.077} height={40} viewBox="0 0 31.077 40" {...props}>
            <Path d="M22.595 9.153c-2.853 0-5.189 1.742-6.683 1.742-1.588 0-3.657-1.627-6.147-1.627-4.728 0-9.516 3.907-9.516 11.26 0 4.595 1.762 9.439 3.964 12.561 1.876 2.642 3.523 4.806 5.898 4.806 2.335 0 3.37-1.551 6.28-1.551 2.949 0 3.619 1.513 6.204 1.513 2.566 0 4.27-2.355 5.897-4.672 1.8-2.662 2.567-5.247 2.585-5.381-.153-.038-5.055-2.049-5.055-7.659 0-4.864 3.849-7.047 4.078-7.219-2.546-3.657-6.433-3.772-7.506-3.772m-1.339-3.103c1.168-1.417 1.99-3.351 1.99-5.304 0-.269-.019-.536-.057-.747-1.915.076-4.213 1.265-5.571 2.873-1.092 1.225-2.088 3.178-2.088 5.131 0 .307.059.594.077.689.115.02.307.058.517.058 1.705 0 3.849-1.149 5.132-2.7" />
        </Svg>
    );
};

export default React.memo(AppleLogo);
